import { HelpersService } from './../../services/helpers.service';
import { AuthService } from './../../services/auth.service';
import { DatabaseService } from './../../services/database.service';
import { Component, OnInit } from '@angular/core';
import { Avaliacao, EquipeAvaliada, AvaliacaoList } from '../../models/avaliacao.model';
import { Equipe, EntregaEquipe } from '../../models/equipe.model';
import { User } from 'src/app/models/user.model';

@Component({
  selector: 'app-avaliador',
  templateUrl: './avaliador.component.html',
  styleUrls: ['./avaliador.component.css']
})
export class AvaliadorComponent implements OnInit {

  showSpinner = true;
  private uidAvaliador = '';
  private avaliacao: AvaliacaoList;

  constructor(private helper: HelpersService,
              private auth: AuthService,
              private database: DatabaseService) { }

  ngOnInit(): void {
    this.auth.getUser.then((user: User) => {
      this.uidAvaliador = user.user.uid;
      this.buscarAvaliacoes();
    });
  }

  private buscarAvaliacoes(): void {
    this.database.getAvaliacao(this.helper.hackathonId, this.uidAvaliador)
    .then(rawData => rawData.subscribe( (avalicoes: AvaliacaoList[]) => {
      this.avaliacao = avalicoes.find(a => a.uidAvaliador === this.uidAvaliador);

      if (this.helper.isNullOrUndefined(this.avaliacao)) {
        this.avaliacao = this.inicializarObjetoAvaliacoes();
        this.database.updateAvaliacao(this.avaliacao);
      }

      this.buscarEAdicionarNovasAvaliacoes();
    }));
  }

  private buscarEAdicionarNovasAvaliacoes(): void {
    this.helper.openSnackBar('Buscando avaliações!', 'Tudo bem');

    this.database.getEquipes(this.helper.hackathonId)
    .then(rawData => rawData.subscribe((equipes: Equipe[]) => {
      equipes.forEach((equipe: Equipe) => {

        this.verificarSeEquipeExiste(equipe);

        equipe.entregas.forEach(entrega => {
          if (entrega.avaliativa) {
            this.verificarSePossuiAvaliacao(equipe.equipeId, entrega);
          }
        });

      });
      this.verificarSeExistemAvaliacoes();
    }));
  }

  private verificarSeEquipeExiste(equipe: Equipe): void {
    const equipeIndex = this.avaliacao.equipesAvaliadas.findIndex(e => e.equipeId === equipe.equipeId);
    if (equipeIndex === -1) {
      this.avaliacao.equipesAvaliadas.push({
        equipeId: equipe.equipeId,
        desafioEscolhido: equipe.desafioEscolhido,
        nomeEquipe: equipe.nomeEquipe,
        avaliacoes: []
      });
    } else {
      this.avaliacao.equipesAvaliadas[equipeIndex].desafioEscolhido = equipe.desafioEscolhido;
    }
  }

  private verificarSePossuiAvaliacao(equipeId: string, entrega: EntregaEquipe): void {
    const equipeIndex = this.avaliacao.equipesAvaliadas.findIndex(e => e.equipeId === equipeId);

    if (equipeIndex > -1) {
      const entregaIndex = this.avaliacao.equipesAvaliadas[equipeIndex].avaliacoes.findIndex(e => e.titulo === entrega.titulo);

      if (entregaIndex > -1) {
        this.avaliacao.equipesAvaliadas[equipeIndex].avaliacoes[entregaIndex].entrega = entrega.conteudo;
      } else {
        this.adicionarAvaliacao(equipeIndex, entrega);
      }

    }
  }

  private adicionarAvaliacao(equipeIndex: number, entrega: EntregaEquipe): void {
    // adiciciona a avaliacao
    this.avaliacao.equipesAvaliadas[equipeIndex].avaliacoes.push({
      avaliativa: entrega.avaliativa,
      titulo: entrega.titulo,
      entrega: entrega.conteudo,
      pontuacao: 0,
    });
  }

  private verificarSeExistemAvaliacoes(): void {
    if (this.avaliacao.equipesAvaliadas.length === 0) {
      this.helper.openSnackBar('Não existem avaliações disponíveis ainda!', 'Tudo bem');
      this.helper.routeToDetalhes();
    } else {
      this.helper.openSnackBar('Boas avaliações!', ':D');
      this.showSpinner = false;
    }
  }

  private inicializarObjetoAvaliacoes(): AvaliacaoList {
    return {
      uidAvaliador: this.uidAvaliador,
      hackathonId: this.helper.hackathonId,
      equipesAvaliadas: [],
    };
  }

  getAvaliacoes(): EquipeAvaliada[] {
    return this.avaliacao.equipesAvaliadas;
  }

  salvar(): void {
    this.database.updateAvaliacao(this.avaliacao);
    this.helper.openSnackBar('Avaliações salvas! ;D', 'Gratidão!');
  }

}
